// extracted by mini-css-extract-plugin
export default {"pageSizeValue":"BasicSelect_pageSizeValue__Y0gzl"};